<template>
  <div style="margin: 12px 12px">
    <!--#region Header -->
    <div class="col-lg-12 title text-center">STUDENT ATTENDANCE REPORT</div>
    <div class="col-lg-12 title text-center">"{{ fromDate }}" to "{{ toDate }}"</div>
    <div class="col-lg-12 title">STUDENT TYPES: {{ studentTypes }}</div>

    <!--#endregion Header -->

    <!--#region Body  -->
    <div class="container">
      <template v-for="student in Data">
        <!--#region Name and Percentage  -->
        <hr />
        <div class="row">
          <div class="col-lg-12 percentage text-right">Attendance Percentage: {{ student['absentPerc'] }} %</div>
          <div class="col-lg-12 text-left">{{ student['Full_Name'] }} {{ student['Last_name'] }} ({{ student['CRS_Course_Name'] }})</div>
          <br />
          <ul style="list-style: none">
            <template v-for="item in student['AbsenceReason']">
              <li class="text-left">{{ item['Date'] }} ({{ item['Reason'] }}: {{ item['Remarks'] }})</li>
            </template>
          </ul>
        </div>
        <!--#endregion Name and Percentage-->
      </template>
    </div>
    <!--#endregion Body -->
  </div>
</template>

<script>
export default {
  name: 'ReportContent',
  props: ['Data', 'fromDate', 'toDate', 'studentTypes'],
}
</script>

<style scoped></style>
